import React from 'react';
import styles from './galleryPage.module.css'
import Header from "../../components/header/header";
import Gallery from '../../components/gallery/gallery'


const GalleryPage = (props) => {
	return <div className={styles.container}>
		<Header/>
		<div >
			<div className={styles.content}>
				
		<Gallery/>
			</div>
		</div>
	</div>
}

export default GalleryPage